module.exports = __webpack_public_path__ + "0face3564cb5c3279775ee4c2d6974be.png";